/** Default hard minimum width for split content. */
export const DEFAULT_SPLIT_MIN_WIDTH = 400;
